import { lazy, Suspense } from "react";
import { PowerOff } from "lucide-react";
import { EmptyState } from "@/components/app/EmptyState";
import { RouteFallback } from "@/components/public/RouteFallback";
import { CRM_DISABLED_MESSAGE, CRM_DISABLED_TITLE } from "@/lib/outletFeatures";

// The full app shell is only needed when a top-level CRM route is opened while
// CRM is off. Loading it lazily keeps the sidebar out of the entry chunk.
const RestrictedShell = lazy(() => import("@/components/auth/RestrictedShell"));

/** The calm "not available" state for a CRM screen while CRM is switched off for the outlet. */
export function CrmDisabledNotice() {
  return (
    <EmptyState
      icon={PowerOff}
      title={CRM_DISABLED_TITLE}
      description={CRM_DISABLED_MESSAGE}
      headingLevel={2}
      className="py-16"
    />
  );
}

/** Route-level: the notice inside the staff app shell (or alone when the route already sits in a layout). */
export function CrmDisabledRoute({ nested }: { nested?: boolean }) {
  if (nested) return <CrmDisabledNotice />;
  return (
    <Suspense fallback={<RouteFallback />}>
      <RestrictedShell>
        <CrmDisabledNotice />
      </RestrictedShell>
    </Suspense>
  );
}
